import { Fragment } from 'react';

import { Heading } from '@/hen-ui/atomics/Heading';
import { Icon } from '@/hen-ui/atomics/Icon';
import { Text } from '@/hen-ui/atomics/Text';
import { Flex } from '@/hen-ui/composites/Flex';

import { CareerExplorerTrajectoryStep } from './CareerExplorerTrajectoryStep';
import type { CareerExplorerTrajectory as CareerExplorerTrajectoryData } from './types';

export const CareerExplorerTrajectory = ({
  currentStepId,
  description,
  icon,
  steps = [],
  title,
}: CareerExplorerTrajectoryData) => (
  <Flex gap='none' className='rounded-lg bg-secondary-700 px-xl py-d3'>
    <Flex direction='row' align='center' gap='xxs' className='mb-sm'>
      <Icon
        icon={icon}
        size='md'
        strokeWidth={1.5}
        className='text-white'
        aria-hidden='true'
      />
      <Heading
        variant='h2'
        className='text-white font-semibold text-h5 md:text-h3 md:leading-h3'
      >
        {title}
      </Heading>
    </Flex>

    <Text
      variant='b2'
      className='mb-lg font-light text-white text-b4 lg:text-b3 lg:leading-b3'
    >
      {description}
    </Text>

    {steps.length > 0 && (
      <Flex direction='column' direction-md='row' gap='sm'>
        {steps.map((step, index) => {
          const stepCard = (
            <CareerExplorerTrajectoryStep
              {...step}
              current={step.id === currentStepId}
            />
          );

          if (index === 0) {
            return <Fragment key={step.id}>{stepCard}</Fragment>;
          }

          return (
            <Flex
              key={step.id}
              direction='row'
              align='start'
              align-md='center'
              gap='sm'
              className='md:contents'
            >
              <Icon
                icon='arrow-right-circle'
                size='md'
                strokeWidth={1.5}
                className='shrink-0 text-white md:self-center'
                aria-hidden='true'
              />
              {stepCard}
            </Flex>
          );
        })}
      </Flex>
    )}
  </Flex>
);
